import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { add } from 'date-fns';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'add-procedures',
  templateUrl: './add-procedures.component.html',
  styleUrls: ['./add-procedures.component.css'],
})
export class AddProceduresComponent extends BaseComponent implements OnInit {
  public healthcareSelected: Healthcareservice[] = [];
  public healthcareservice: Healthcareservice[] = [];

  public organizationSelected: any = {};
  public practitioner: any = {};
  public specialtysPractitionerOrganizationIds: string[] = [];

  public address !: any

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private healthcareService: ProcedureService,
    private practitionerOrganizationAffiliationService: PractitionerOrganizationAffiliationService,
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
   
    this.organizationSelected = this.currentUser.user
    this.practitioner = this.data.param.practitioner;

    this.getAffiliationPractitionerOrganization();
  }

  getAffiliationPractitionerOrganization() {
    const organization_id = this.organizationSelected.id;
    const practitioner_id = this.practitioner.practitioner_id

     console.log("organization selected", this.organizationSelected)
     console.log("practitioner selected", this.practitioner)

    this.practitionerOrganizationAffiliationService.listByPractitionerOrganization(organization_id, practitioner_id).subscribe({
      next: (resPractitioner: any) => {
        this.specialtysPractitionerOrganizationIds = resPractitioner.specialty
          .filter((specialty: any) => specialty.status == 'accepted' || specialty.status == 'requested')
          .map((specialty: any) => specialty.id);

        console.log("practitioner", resPractitioner)

        this.getHealthcareService();
      },
      error: (err) => {
        console.log('Falha ao listar especialista', err);
      },
    });
  }
 
  getLocation() {
    //  this.loading = true
    //  const organization_id = this.getUserLogged().id;
    //  this.organizationLocationService.showByOrganization(organization_id).subscribe({
    //    next: (organizationLocation: Location) => {
 
      
 
    //      this.loading = false
    //      this.hasLocation = true
    //    },
    //    error: (error: HttpErrorResponse) => {
 
    //      const erroType = error?.error?.error
 
    //      if (error.status == 404 && erroType == "Not Found") {
    //        this.checkLocationPermissionAndGetPosition();
 
           
    //        this.showWarningMessage = true
    //        this.messageWarning = "A visibilidade da organização no sistema depende do cadastro da localizacão"
    //        this.onUpdateLocation.emit(<Location>{})
           
    //      }
 
 
    //      this.loading = false
 
    //    },
    //  });
   }


  getHealthcareService() {

    this.loading = true

    this.healthcareService.listByOrganizations(this.organizationSelected.id).subscribe({
      next: (resHealth: Healthcareservice[]) => {
        this.healthcareservice = resHealth.filter(healthcareservice => healthcareservice.serviceDealer == "Especialista" );
        this.loading = false
      },
      error: (err) => {
        this.loading = false
        console.log('Falha ao listar healthcare Service', err);
      },
    });
  }

  addProcedures() {
    const organizationFilter = {
      organization_id: this.organizationSelected.id,
      organization_name: this.organizationSelected.name,
      organization_photo: this.organizationSelected.photo,
      organization_address: this.address,
    };

    const practitionerFilter = {
      practitioner_id: this.practitioner.practitioner_id,
      practitioner_name: this.practitioner.name,
      practitioner_photo: this.practitioner.photo,
      practitioner_details: {
        accessibilities: this.practitioner.accessibilities,
        address: this.practitioner.address,
        communication: this.practitioner.communication,
        cpf: this.practitioner.cpf,
        qualification: this.practitioner.qualification,
        birthDate: this.practitioner.birthDate,
        gender: this.practitioner.gender,
        indentifiers: this.practitioner.identifiers
      },
    };

    const specialty = this.healthcareSelected.map(function (healthcareservice: any) {
      return {
        id: healthcareservice.healthcareservice_id,
        referenceType: 'Healthcareservice',
        display: healthcareservice.name,
        averageDuration: healthcareservice.averageDuration ?? "30",
        status: 'accepted',
      };
    });



    const currentDate = new Date().toISOString();

    const affiliation = {
      ...organizationFilter,
      ...practitionerFilter,
      specialty: specialty,
      requestDateTime: currentDate,
      updateDateTime: currentDate,
    };

    const organizationPratitionerAfffiliationFHIR = this.transformObjectToFHIR(affiliation);

    this.practitionerOrganizationAffiliationService.create(organizationPratitionerAfffiliationFHIR).subscribe({
      next: (resAffiliation) => {
        location.reload()
      },
      error: (response: HttpErrorResponse) => {
        this.showErrorMessage = true
        this.messageError = response.message
      },
    });
  }

  isAlreadyLinked(item: Healthcareservice): boolean {
    return this.specialtysPractitionerOrganizationIds.includes(item.healthcareservice_id);
  }

  public transformObjectToFHIR(data: any) {
    return {
      resourceType: 'Affiliation',
      request: {
        id: data.practitioner_id,
        referenceType: 'Practitioner',
        display: data.practitioner_name,
        photo: data.practitioner_photo,
        details: data.practitioner_details
      },
      changeRequest: data.changeRequest,
      subject: {
        id: data.organization_id,
        referenceType: 'Organization',
        display: data.organization_name,
        photo: data.organization_photo,
        address: data.organization_address,
      },
      specialty: data.specialty,
      requestDateTime: data.requestDateTime,
      updateDateTime: data.updateDateTime,
      status: 'accepted',
    };
  }
}
